import React from "react";
import { Link } from "react-router-dom";

const badgeColors = {
  Bestseller: "bg-brand-pink",
  New: "bg-brand-mint",
  Limited: "bg-brand-yellow",
};

export default function ProductCard({ product }) {
  return (
    <Link
      to={`/product/${product.product_id}`}
      className="group bg-white neo rounded-2xl overflow-hidden neo-press block"
      data-testid={`product-card-${product.product_id}`}
    >
      <div className="relative aspect-square overflow-hidden border-b-2 border-ink bg-brand-sky/40">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        {product.badge && (
          <span className={`absolute top-3 left-3 ${badgeColors[product.badge] || "bg-brand-yellow"} neo-sm rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wider`}>
            {product.badge}
          </span>
        )}
      </div>
      <div className="p-4 flex items-center justify-between gap-2">
        <div>
          <h3 className="font-display font-bold text-lg leading-tight">{product.name}</h3>
          <p className="text-xs font-bold uppercase tracking-wider text-ink/50">{product.category}</p>
        </div>
        <span className="font-display font-bold text-lg bg-brand-yellow neo-sm rounded-lg px-2.5 py-1 shrink-0">
          ${product.price.toFixed(2)}
        </span>
      </div>
    </Link>
  );
}
